import request from '@/modules/base/util/request'
import settingsConfig from '@/modules/settings/config'

// actions
const ACTION_PREFIX = 'customerCenter/settings'
const SET_DATA = `${ACTION_PREFIX}/setData`
const SET_ERROR = `${ACTION_PREFIX}/setError`

const initialState = {
  tenantLogo: null,
  showLogo: null,
  contactEmail: null,
  contactPhone: null,
  eSignatureEnabled: false,
}

// reducer
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_DATA:
      const { data } = action
      return { ...state, ...data }
    case SET_ERROR:
      const { error } = action
      return { ...state, error }
    default:
      return state
  }
};

export const updateData = (data) => {
  return {
    type: SET_DATA,
    data,
  }
}

export const setError = (error) => {
  return {
    type: SET_ERROR,
    error,
  }
}

export const fetchData = () => {
  return (dispatch) => {
    request(settingsConfig.getCustomerCenterSettings, { auth: true, method: 'GET' })
      .then(({ body: { data: {
        tenantLogo,
        showLogo,
        contactEmail,
        contactPhone,
        autoEnableInvoicePaymentProviders,
        autoEnableOrderPaymentProviders,
        gamificationCompleted,
        eSignatureEnabled,
      } } }) => {
        dispatch(updateData({
          tenantLogo,
          showLogo,
          contactEmail,
          contactPhone,
          autoEnableInvoicePaymentProviders,
          autoEnableOrderPaymentProviders,
          gamificationCompleted,
          eSignatureEnabled,
        }))
      })
      .catch((error) => {
        dispatch(setError(error))
      })
  }
}
